import React from 'react';

// Translations
import translate from './Translate.js';

// Components
import * as icons from './Icons/Icons';

class SessionExpired extends React.Component {
  render() {
    const { translation } = this.props;

    return(
      <main tabIndex="0" id="main-content" className="page page--error wrap">
        <div className="panel--brief">
          <i className="page--error__icon"><icons.iconClock /></i>

          <div>
            <h1 className="panel__title">{translation.heading}</h1>
            <p>{translation.message}</p>
          </div>
        </div>
      </main>
    )
  }
}

export default translate('SessionExpired')(SessionExpired);


// WEBPACK FOOTER //
// ./src/app/components/SessionExpired.js